import React from 'react';
import { Wrapper } from './styles';
import { useWindowSize } from '@reach/window-size';

interface Props{
    placement: 'left' | 'right';
    open: boolean;
    title: string;
    onClose: any;
    children?: React.ReactNode;
}


const DrawerContainer = ({placement, open, title, onClose, children}: Props) => {

  const { width } = useWindowSize()

  return (
    <Wrapper width={width < 531 ? '100vw' : '378px'} placement={placement} open={open} title={title} onClose={onClose}>
        {children}
    </Wrapper>
  )
}

export default DrawerContainer;